import React from "react";
import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import { AUTHENTICATED_ENTRY } from "configs/AppConfig";
import { protectedRoutes, publicRoutes } from "configs/RoutesConfig";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import AppRoute from "./AppRoute";
import { USER_INFO } from "constants/AuthConstant";
import { setUserInfo } from "store/slices/accountSlice";
import { useDispatch } from "react-redux";
const Routes = () => {
  const dispatch = useDispatch();

  const loggedInRole = JSON.parse(localStorage.getItem(USER_INFO))?.role ?? "";
  dispatch(setUserInfo(loggedInRole));

  const protectedRoutesBasedOnRole = protectedRoutes.filter((route) => {
    if (route.roles && route.roles.length > 0) {
      return route.roles.some((role) => loggedInRole && loggedInRole === role);
    }

    return true;
  });
  return (
    <RouterRoutes>
      <Route path="/" element={<ProtectedRoute />}>
        <Route
          path="/"
          element={<Navigate replace to={AUTHENTICATED_ENTRY} />}
        />
        {protectedRoutesBasedOnRole.map((route, index) => {
          return (
            <Route
              key={route.key + index}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          );
        })}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
      <Route path="/" element={<PublicRoute />}>
        {publicRoutes.map((route) => {
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          );
        })}
      </Route>
    </RouterRoutes>
  );
};

export default Routes;
